import React from "react";
import { Trans, useTranslation } from "react-i18next";
import appConfig from "../../app.config";

function Footer() {
  const { t, i18n } = useTranslation();
  const footerKey =
    i18n.language.toLowerCase() === "en"
      ? "__footer_" + appConfig.country
      : "__footer";
  const currentYear = new Date().getFullYear();

  return (
    <div id="footer" className="container-fluid">
      <div className="navbar navbar-fixed-bottom" id="footerContent">
        <p className="text-center">
          &copy; <Trans i18nKey={footerKey} values={{ year: currentYear }} />
        </p>
      </div>
    </div>
  );
}

export default Footer;